module.exports = __webpack_public_path__ + "ro.af874e87abb5b4080217.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ro.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ro.svg
// module chunks = styles